const _extractQueryParams = (qString) => {
  if (!qString) return [];
  // 1. remove the '?' at the beginning
  // 2. split on each '&' to achieve a list of 'x=y' strings.
  // 3. split each 'x=y' string into a list [x, y], and then decode each of x and y.
  return qString.substring(1).split('&').map(x => x.split('=').map(y => decodeURIComponent(y)));
};

const _compileQueryParams = (qParams) => {
  if (!qParams) return '';
  const encodedTokens = qParams.map(pair => `${encodeURIComponent(pair[0])}=${encodeURIComponent(pair[1])}`);
  if (encodedTokens.length === 0) return '';
  return `?${encodedTokens.join('&')}`;
};

export function getQueryParam(qString, param) {
  const qParams = _extractQueryParams(qString);
  for (let i = 0; i < qParams.length; ++i) {
    if (qParams[i][0] === param) return qParams[i][1];
  }
  return null;
}

export function changeQueryParam(qString, param, newValue) {
  const qParams = _extractQueryParams(qString);
  let changed = false;
  for (let i = 0; i < qParams.length; ++i) {
    if (qParams[i][0] === param) {
      qParams[i][1] = newValue;
      changed = true;
      break;
    }
  }
  if (!changed) {
    qParams.push([param, newValue]);
  }
  return _compileQueryParams(qParams);
}

export function removeQueryParam(qString, param) {
  return _compileQueryParams(_extractQueryParams(qString).filter(pair => pair[0] !== param));
}
